class ComponentCollectionSlider extends Theme.Component {
  constructor() {
    super();

    this.defineElements({
      slider: ".collection-slider",
      previous_button: "button:first-of-type",
      next_button: "button:last-of-type"
    });

    this.elements.slider_items = document.querySelectorAll(".collection-slider-item");
  }

  connectedCallback() {
    this.observer();
    this.events();
  }

  observer() {
    const observer = new ResizeObserver((entries) => {
      entries.forEach(entry => {
        const width = entry.contentRect.width;

        if (this.slider) {
          this.teardown();
        }

        this.setup(width);
      });
    });

    observer.observe(this);
  }

  setup(width) {
    let options = {
      cellAlign: "left",
      contain: true,
      pageDots: false,
      prevNextButtons: false,
      wrapAround: true,
      groupCells: 4
    };

    if (width < 1024) {
      options.dragThreshold = 10;
      options.groupCells = 2;
    }

    if (width < 767) {
      return;
    }

    this.slider = new Flickity(this.elements.slider, options);

    this.elements.slider_items.forEach((element) => {
      element.style.height = "100%";
    });
  }

  teardown() {
    this.slider.destroy();

    this.elements.slider_items.forEach((element) => {
      element.style.height = "auto";
    });
  }

  next() {
    this.slider.next();
  }

  previous() {
    this.slider.previous();
  }
}

customElements.define("component-collection-slider", ComponentCollectionSlider);
